var styleDataHash = "c554030f";
const injectCss = (() => {
  var css = `._1uNyE,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.Cilmw{align-items:center;background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-color-text-standard-primary,var(--wsr-color-D10,#000624));cursor:pointer;display:flex;min-height:36px;padding-block:var(--ricos-internal-list-item-select-padding-block,6px);padding-inline:var(--ricos-internal-list-item-select-padding-inline,18px);--wds-color-text-standard-secondary:var(
    --wds-list-item-select-subtitle,var(--wsr-color-D40,#868aa5)
  )}.Cilmw:hover{background-color:var(--wds-list-item-select-fill-hover,var(--wsr-color-B50,#e7f0ff))}.Cilmw.s-Dnx,.Cilmw:active{background-color:var(--wds-list-item-select-active-fill,var(--wsr-color-B10,#116dff));--wds-color-text-standard-primary:var(
    --wds-list-item-select-active-title,var(--wsr-color-D80,#fff)
  );--wds-color-text-standard-secondary:var(
    --wds-list-item-select-active-subtitle,var(--wsr-color-D80,#fff)
  )}.Cilmw.s-Dnx:hover{background-color:var(--wds-list-item-select-active-fill-hover,var(--wsr-color-B20,#5999ff))}.Cilmw._4br8K{background-color:var(--wds-list-item-select-fill,var(--wsr-color-D80,#fff));color:var(--wds-list-item-select-title-disabled,var(--wsr-color-D10-30,rgba(0,6,36,.3)));cursor:auto;pointer-events:none}.Cilmw:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important;outline-offset:-2px}.Cilmw.QBPp5{--wds-font-size-body-medium:16px}.Cilmw.WnRjV{min-height:54px}.outre{column-gap:6px;display:grid;flex:1;grid-template-areas:"prefix title suffix";grid-template-columns:max-content 1fr max-content;grid-template-rows:auto auto}.WnRjV{grid-template-areas:"prefix title suffix" "prefix subtitle suffix"}.irXmE{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:prefix}.lZL-Y{align-self:center;grid-area:title}.lZL-Y,.mCnzw{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.mCnzw{grid-area:subtitle}.PckUW{align-items:center;align-self:center;display:flex;flex-shrink:0;grid-area:suffix}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_select_default = {
  "fontElementMap": "_1uNyE",
  "root": "Cilmw",
  "selected": "s-Dnx",
  "disabled": "_4br8K",
  "mobile": "QBPp5",
  "withSubtitle": "WnRjV",
  "content": "outre",
  "prefix": "irXmE",
  "title": "lZL-Y",
  "subtitle": "mCnzw",
  "suffix": "PckUW"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
